var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.192,
    height: 24.5,
    x: 0.25,
    y: 0.25,
    fill: "#FAFAFA",
    stroke: "#333",
    strokeOpacity: 0.05,
    strokeWidth: 0.5,
    rx: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    d: "M18.198 6.791a7.28 7.28 0 0 1 4.656-1.663c3.964 0 7.177 3.117 7.177 6.963 0 3.845-3.213 6.962-7.177 6.962a7.28 7.28 0 0 1-4.656-1.663 7.28 7.28 0 0 1-4.655 1.663c-3.964 0-7.178-3.117-7.178-6.962 0-3.846 3.214-6.963 7.178-6.963a7.28 7.28 0 0 1 4.655 1.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    d: "M18.198 6.791c-1.543 1.277-2.521 3.178-2.521 5.3s.978 4.022 2.521 5.299a7.28 7.28 0 0 1-4.655 1.663c-3.964 0-7.178-3.117-7.178-6.962 0-3.846 3.214-6.963 7.178-6.963a7.28 7.28 0 0 1 4.655 1.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    d: "M18.198 17.39c1.543-1.277 2.522-3.177 2.522-5.3 0-2.121-.979-4.022-2.522-5.299a7.28 7.28 0 0 1 4.656-1.663c3.964 0 7.177 3.117 7.177 6.963 0 3.845-3.213 6.962-7.177 6.962a7.28 7.28 0 0 1-4.656-1.663z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.f1c6f5d94a2c4935feea44fc7305fef7.svg";
export { ForwardRef as ReactComponent };